import {
  SUPER_ADMIN_ARCHIVE_ACTIVE_EOT,
  SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_ERROR,
  SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_RESET,
  SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_SUCCESS,
  SUPER_ADMIN_FETCH_ACTIVE_EOT,
  SUPER_ADMIN_FETCH_ACTIVE_EOT_ERROR,
  SUPER_ADMIN_FETCH_ACTIVE_EOT_SUCCESS,
} from '../types';

type RequestStatus = null | 'pending' | 'success' | 'error';

interface ArchiveActiveEotState {
  fetchStatus: RequestStatus;
  fetchError: string | null | undefined;
  eot: Record<string, unknown> | null | undefined;
  archiveStatus: RequestStatus;
  archiveError: string | null | undefined;
}

interface ArchiveActiveEotAction {
  type: string;
  eot?: Record<string, unknown> | null;
  message?: string | null;
}

const initialState: ArchiveActiveEotState = {
  fetchStatus: null, // null | 'pending' | 'success' | 'error'
  fetchError: null,
  eot: null, // { id, startDate, endDate, ... }
  archiveStatus: null, // null | 'pending' | 'success' | 'error'
  archiveError: null,
};

export default function archiveActiveEot(
  state: ArchiveActiveEotState = initialState,
  action: ArchiveActiveEotAction,
): ArchiveActiveEotState {
  switch (action.type) {
    case SUPER_ADMIN_FETCH_ACTIVE_EOT:
      return { ...initialState, fetchStatus: 'pending' };
    case SUPER_ADMIN_FETCH_ACTIVE_EOT_SUCCESS:
      return { ...state, fetchStatus: 'success', eot: action.eot };
    case SUPER_ADMIN_FETCH_ACTIVE_EOT_ERROR:
      return { ...state, fetchStatus: 'error', fetchError: action.message };
    case SUPER_ADMIN_ARCHIVE_ACTIVE_EOT:
      return { ...state, archiveStatus: 'pending', archiveError: null };
    case SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_SUCCESS:
      return { ...state, archiveStatus: 'success' };
    case SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_ERROR:
      return { ...state, archiveStatus: 'error', archiveError: action.message };
    case SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_RESET:
      return initialState;
    default:
      return state;
  }
}
